<div>
    <div class="confirmation-dialog_message">
        @if (contentModel.icon) {
            <i [ngClass]="contentModel.icon"></i>
        }
        {{ contentModel.message }}
    </div>
    @if (contentModel.buttons.length && isDesignSystem) {
        <div class="confirmation-dialog_buttons-container">
            @for (button of contentModel.buttons; track $index) {
                @if (button.buttonConfig) {
                    <button
                        class="confirmation-dialog_button"
                        ds-button
                        [kind]="button.buttonConfig.kind"
                        [variant]="button.buttonConfig.variant"
                        [size]="button.buttonConfig.size"
                        [wrapText]="true"
                        [class]="{ 'single-button': contentModel.buttons.length === 1 } + ' ' + button.buttonOrderClass"
                        (click)="handleClick(button)">
                        {{ button.buttonTitle?.trim() }}
                    </button>
                }
            }
        </div>
    } @else {
        <div class="confirmation-dialog_buttons">
            @for (button of contentModel.buttons; track $index) {
                <button [ngClass]="button.cssClass" (click)="handleClick(button)">
                    {{ button.buttonTitle }}
                </button>
            }
        </div>
    }
</div>
